import { Component, Inject, NgZone, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { EmployementPaymentOrder } from 'src/@core/interfaces/employment/employement-payment-order.model';
import { AppService } from 'src/@core/services/app.service';
import { CreditsService } from 'src/@core/services/credits/credits.service';
import { EmployeerPaymentOrderService } from 'src/@core/services/employment/employment-payment-order.service';
import { environment } from 'src/environments/environment';
declare var Razorpay: any;

@Component({
  selector: 'hour4u-admin-add-credit',
  templateUrl: './add-credit.component.html',
  styleUrls: ['./add-credit.component.scss']
})
export class AddCreditComponent implements OnInit {
  creditAmount: number = 0;
  creditForm: FormGroup;
  isLoading: boolean = false;
  isPayLaterClick: boolean = false;
  diameter = 40;
  loaderColor: string;
  mode = 'indeterminate';
  hoursList: any[] = [
    {
      id: 7,
      label: '7 days'
    },
    {
      id: 15,
      label: '15 days'
    },
    {
      id: 21,
      label: '21 days'
    },
    {
      id: 60,
      label: '30 days'
    },
    {
      id: 45,
      label: '45 days'
    },
    {
      id: 60,
      label: '60 days'
    },
    {
      id: 3,
      label: '3 months'
    },
    {
      id: 6,
      label: '6 months'
    },
    {
      id: 1,
      label: '1 year'
    }
  ];
  profile = this.appService.getCurrentAccount();

  constructor(
    public dialogRef: MatDialogRef<AddCreditComponent>,
    @Inject(MAT_DIALOG_DATA) public selectedData: any,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _fb: FormBuilder,
    public creditsService: CreditsService,
    private appService: AppService,
    private zone: NgZone
  ) { }

  ngOnInit() {
    console.log(this.selectedData, this.profile);
    console.log("data", this.data.currentPlan);
    this.creditForm = this._fb.group({
      creditAmount: [null, [Validators.required]],
      checkGST: [false],
      gstNumber: [null],
      companyName: [null],
      selectedDuration: [],
      check: [false]
    })

    // Watch for changes to checkGST and adjust validations dynamically
    this.creditForm.get('checkGST').valueChanges.subscribe((checkGST) => {
      if (checkGST) {
        this.creditForm.get('gstNumber').setValidators([Validators.required, this.gstValidator()]);
        this.creditForm.get('companyName').setValidators([Validators.required]);
      } else {
        this.creditForm.get('gstNumber').clearValidators();
        this.creditForm.get('companyName').clearValidators();
      }
      this.creditForm.get('gstNumber').updateValueAndValidity();
      this.creditForm.get('companyName').updateValueAndValidity();
    });
  }

  gstValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{3}$/;
      const value = control.value;

      // If the field is empty, don't validate (return null).
      if (!value) {
        return null;
      }

      const valid = gstRegex.test(value);
      return valid ? null : { invalidGst: true };
    };
  }

  payLater() {
    this.isPayLaterClick = true;
    this.creditForm.controls['selectedDuration'].setValidators([Validators.required]);
    this.creditForm.controls['check'].setValidators([Validators.required]);
    this.creditForm.controls['selectedDuration'].updateValueAndValidity();
    this.creditForm.controls['check'].updateValueAndValidity();
  }

  payNow() {
    this.isPayLaterClick = false;
    this.creditForm.controls['selectedDuration'].setValidators([]);
    this.creditForm.controls['check'].setValidators([]);
    this.creditForm.controls['selectedDuration'].updateValueAndValidity();
    this.creditForm.controls['check'].updateValueAndValidity();
    this.requestCredit("TOP_UP");
  }

  openPaymentGateway(obj) {
    console.log(obj);
    this.razorPayOptions.amount = this.getTotalAmount() * 100; // Corrected to pass the calculated amount
    this.razorPayOptions.currency = 'INR';
    this.razorPayOptions.key = environment.rezorpayKey;
    this.razorPayOptions.order_id = obj.checkoutOrder.razorPayOrderId;
    console.log("this.razorPayOptions", this.razorPayOptions)
    var rzp = new Razorpay(this.razorPayOptions);
    rzp.open()
    rzp.on('payment.failed', function (response) {
      console.log("response--", response)
      alert(response.error.code);
      alert(response.error.description);
      alert(response.error.source);
      alert(response.error.step);
      alert(response.error.reason);
      alert(response.error.metadata.order_id);
      alert(response.error.metadata.payment_id);
    });
  }

  razorPayOptions = {
    "key": '',
    "amount": 0,
    "currency": '',
    "name": '',
    "discription": "hours4u payment",
    "order_id": '',
    "handler": (response) => {
      console.log(response)
      let paymentOrderRequest = new EmployementPaymentOrder();
      paymentOrderRequest.razorpay_order_id = response.razorpay_order_id;
      paymentOrderRequest.razorpay_payment_id = response.razorpay_payment_id;
      paymentOrderRequest.razorpay_signature = response.razorpay_signature;
      this.creditsService.updatePaymentStatusOrderId(response.razorpay_order_id, paymentOrderRequest).toPromise().then(res => {
        this.closePopup();
      })
    },
    "modal": {
      "ondismiss": () => {
        this.closePopup();
      }
    }
  };

  closePopup() {
    this.zone.run(() => {
      this.dialogRef.close(true);
    });
  }

  requestCredit(rechargeType) {
    this.isLoading = true;
    let obj = {
      "entityId": this.profile.entity.id,
      "amount": this.getTotalAmount(),
      "amountWithGST": this.creditForm.controls['creditAmount'].value * 1.18,
      "rechargeType": rechargeType,
      "walletType": this.selectedData.forWhat,
      "companyName": this.creditForm.controls['companyName'].value,
      "gstNumber": this.creditForm.controls['gstNumber'].value,
      "metaData": {
        "name": this.profile.user.userMeta.name,
        "email": this.profile.user.email,
        "mobile": this.profile.user.mobile,
        "duration": this.creditForm.controls['selectedDuration'].value,
      }
    }

    this.creditsService.sendRequestForCredit(obj).subscribe(res => {
      console.log(res)
      this.isLoading = false;
      if (rechargeType == 'TOP_UP') {
        this.openPaymentGateway(res);
      } else {
        this.dialogRef.close(true);
      }
    }, ((err: any) => {
      this.isLoading = false;
    }))
  }

  selectedChangeGST(event: any) {
    if (!event.checked) {
      this.creditForm.get('gstNumber').setValue("");
      this.creditForm.get('companyName').setValue("");
    }
  }

  getRatePerCredit(): number {
    const plan = this.data.currentPlan.toUpperCase(); // Plan name

    // Define the rates for each plan
    const rates = {
      FREE_TRIAL: 3.5,
      STARTER: 2.5,
      POPULAR: 2.0,
      BUSINESS: 1.5,
      GROWTH: 1
    };

    // Return the corresponding rate for the plan or default to 3.5 if plan is unrecognized
    return rates[plan] || 3.5;
  }

  getTotalAmount(): number {
    const creditCount = this.creditForm.controls['creditAmount'].value || 0;
    return creditCount * this.getRatePerCredit();
  }
}
